import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CommonAlertService {

  constructor() { }
  public alert: Subject<any> = new Subject();

  showAlertMsg(alertMsg) {
    alertMsg.class = 'alert-danger';
    alertMsg.msg =  'Failure!!';
    this.alert.next(alertMsg);
  }

  showSuccessMsg(alertMsg) {
    alertMsg.class = 'alert-success';
    alertMsg.msg = 'Success !!';
    this.alert.next(alertMsg);
  }

  showEdit(alertMsg) {
    alertMsg.class = 'alert-success';
    alertMsg.msg = 'Updated!!';
    this.alert.next(alertMsg);
  }

  showEmptyMsg(alertMsg) {  	
    alertMsg.class = 'alert-warning';
    alertMsg.msg =  '';
    this.alert.next(alertMsg);
  }

  showWarningMsg(alertMsg) {
    alertMsg.class = 'alert-warning';
    alertMsg.msg = 'Warning !!';
    this.alert.next(alertMsg);
  }

}
